<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-10-19 17:32:39
 * @LastEditors: sjq
 * @LastEditTime: 2023-10-20 09:46:13
 -->
<template>
  <div
    v-if="false"
    class="minheight100 vip-group-detail"
    :style="{ 'background-position-y': appUser.nativeHeaderHeight + 'px' }"
  >
    <app-header v-if="appUser.isNative" back-type="back-app" title="2024友邻节特别活动"></app-header>
    <div class="title">
      <img src="../images/vip_group_title.png" />
    </div>
    <div class="detail-main">
      <div class="detail-title">
        第一步：复制文案
        <img src="../images/vip_group_title_bg.png" alt="" />
      </div>
      <div class="detail-commit">
        <div class="commit">
          {{ text }}
        </div>
      </div>
      <div class="btn-common" @click="copy">点击复制文案</div>
    </div>
    <div class="detail-main">
      <div class="detail-title">第二步：将复制的文案，发送给班主任</div>
      <div class="detail-commit">
        <img :src="detail.adviserErCode" />
        <div class="name">{{ detail.adviserName }}</div>
      </div>
      <div class="btn-common" v-if="appUser.isNative" @click="addAdviser">添加班主任</div>
      <div class="wx-btn" v-else>长按扫一扫，联系班主任参加活动</div>
    </div>
    <!-- <div class="bottom">读外刊，学英文，看世界！</div> -->
  </div>
  <div v-else class="vip-activity-end">报名已截止</div>
</template>
<script>
import { appUser } from '@/utils'
import copyText from '@/utils/clipboard'
import { activityService } from '@/api'
import { $gotoMiniProgramV2 } from '@/utils/common/native-api'

export default {
  name: 'vipGroup',
  components: {},
  data() {
    return {
      appUser,
      text: '报名14天无限卡体验营',
      detail: {}
    }
  },
  computed: {},
  watch: {},
  created() {
    // this.getDetail()
  },
  mounted() {},
  methods: {
    copy($event) {
      copyText(this.text, $event)
    },
    getDetail() {
      activityService.isVipActivity().then(res => {
        console.log(res, 'lll')
        this.detail = res
        //"goType": "camp", // camp:体验营 vip:畅听卡 foreverVip:无限卡
      })
    },
    addAdviser() {
      let id = appUser.isTestEnv ? 15 : 17

      this.$store.dispatch('user/login/getMiniParam', {}).then(mini => {
        $gotoMiniProgramV2({
          miniUserName: mini.miniUserName,
          goMiniUrl: 'pages/rights_receive/app_add_headTeacher/app_add_headTeacher' + '?id=' + id
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.vip-group-detail {
  background: #182969 url(../images/vip_group_bg.png) no-repeat;
  background-position: center;
  background-position-y: top;
  background-size: 100% auto;
  padding-bottom: 1rem;
  position: relative;
}
.title {
  text-align: center;
  padding: 0.44rem 0 0.86rem;
  img {
    width: 6.86rem;
  }
}
.btn-common {
  background-color: #415399;
}
.detail-main {
  margin: 0 0.42rem 0.32rem;
  border-radius: 0.16rem;
  border: 1px solid #fff;
  overflow: hidden;
  background: #fff;
  .detail-title {
    background: var(--1, linear-gradient(189deg, #fff9ed 7.46%, #eccb8c 91.57%));
    color: #415399;
    font-size: 0.3rem;
    font-weight: 700;
    padding: 0.32rem;
    position: relative;
    img {
      position: absolute;
      width: 1.4rem;
      top: -0.1rem;
      right: 0.3rem;
    }
  }

  .detail-commit {
    padding: 0.32rem;
    text-align: center;
    .commit {
      color: rgba($color: #000000, $alpha: 0.85);
      font-size: 0.36rem;
      border-bottom: 1px #000 dashed;
      display: inline-block;
      padding-bottom: 0.24rem;
      margin: 0.6rem 0 0.62rem;
    }
    img {
      width: 2.4rem;
      height: 2.4rem;
      border-radius: 4px;
      border: 1px solid #000;
      margin: 0 auto;
      display: inherit;
    }
    .name {
      text-align: center;
      color: #ff8500;
      font-size: 14px;
      font-weight: 400;
      margin-top: 0.2rem;
    }
  }
  .btn-common {
    margin: 0 0.32rem 0.32rem;
  }
  .wx-btn {
    margin: 0 0.32rem 0.32rem;
    color: rgba($color: #000000, $alpha: 0.5);
    font-size: 0.3rem;
    text-align: center;
  }
}
.bottom {
  color: rgba($color: #fff, $alpha: 0.2);
  text-align: center;
  font-size: 0.28rem;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.24rem;
  position: absolute;
  bottom: 0.24rem;
  left: 0.44rem;
  right: 0;
}
.vip-activity-end {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
